import { FormHelperText, Input, InputLabel, Toolbar } from '@mui/material'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { updateUserid, updateUsername } from '../../../store/userSlice'
import styled from 'styled-components'
import TextBox from '../../Common/TextBox'
import { BlueButton } from '../../Layout/CommonStyle'
import { useEffect, useState } from 'react'
import { axiosPost } from '../../Common/Axios'
import toast from 'react-hot-toast'
import { ApiResult } from '../../../models/Enums'

// type Props = {
//   menuIndex: number
// }Main

function MainPasswd() {
  const me = useAppSelector((state: RootState) => state.user.me)
  const dispatch = useAppDispatch()

  const [password, setPassword] = useState<string>('')
  const [newPassword, setNewPassword] = useState<string>('')
  const [newPassword2, setNewPassword2] = useState<string>('')

  const handleSave = async () => {
    if (password.trim().length === 0) {
      alert('현재 비밀번호를 입력하세요')
      return
    }
    if (newPassword.trim().length === 0) {
      alert('새 비밀번호를 입력하세요')
      return
    }
    if (newPassword2.trim().length === 0) {
      alert('새 비밀번호 확인를 입력하세요')
      return
    }
    if (newPassword.trim() !== newPassword2.trim()) {
      alert('새 비밀번호가 일치하지 않습니다')
      return
    }
    const payload = {
      password,
      newPassword,
      newPassword2,
    }

    const result = await axiosPost('/api/user/update_my_password', payload)
    if (result.apiResult !== ApiResult.SUCCESS) {
      if (result.apiResult === ApiResult.NO_PERMISSION) {
        toast.error('현재 비밀번호가 맞지 않습니다.')
      } else {
        toast.error('저장에 실패했습니다.')
      }
      return
    }

    toast.success('변경했습니다.')
  }

  return (
    <Container>
      <Line>
        <InputLabel htmlFor="component-disabled">현재 비밀번호</InputLabel>
        <input
          type="password"
          placeholder="현재 비밀번호"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Line>

      <Line>
        <InputLabel htmlFor="component-disabled">새 비밀번호</InputLabel>
        <input
          type="password"
          placeholder="새 비밀번호"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </Line>
      <Line>
        <InputLabel htmlFor="component-disabled">새 비밀번호 확인</InputLabel>
        <input
          type="password"
          placeholder="새 비밀번호 확인"
          value={newPassword2}
          onChange={(e) => setNewPassword2(e.target.value)}
        />
      </Line>
      <ButtonBar>
        <BlueButton onClick={() => handleSave()}>저장</BlueButton>
      </ButtonBar>
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
`
const Line = styled.div`
  padding: 10px 0;
  input {
    padding: 10px;
    font-size: 1rem;
    width: 80%;

    &::placeholder {
      color: #ccc;
    }
  }
`
const ButtonBar = styled.div`
  padding: 0px;
`
export default MainPasswd
